import { AtomicBlockUtils, EditorState, Modifier } from 'draft-js';
import { PureComponent } from 'react';

import AttachmentsSelector from 'my-components/AttachmentsSelector';

export default class ImageEditor extends PureComponent {
  confirmImage = image => {
    const { blockImage, editorState, onChange, onClose } = this.props;
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity('IMAGE', 'IMMUTABLE', {
      url: image.urls.original,
      id: image.id,
    });
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    let newEditorState = null;
    if (blockImage) {
      newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntity });
      newEditorState = AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, ' ');
    } else {
      const contentStateWithEntityText = Modifier.insertText(
        contentStateWithEntity,
        editorState.getSelection(),
        ' ',
        null,
        entityKey,
      );
      newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntityText });
    }
    onChange(newEditorState);
    onClose();
  };

  render() {
    const { onClose, onExited, show } = this.props;
    return (
      <AttachmentsSelector
        fileType="image"
        onClose={onClose}
        onExited={onExited}
        onSelect={this.confirmImage}
        open={!!show}
      />
    );
  }
}
